import { WhiteBalanceIncandescentIcon } from './WhiteBalanceIncandescentIcon';

/**
 * author: Google
 * id 4464050A-1A97-46CF-BBA5-CE52D600CB45
 * name white-balance-incandescent
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/white-balance-incandescent.svg
 * tags
 * - Photography 
 */
export const WbIncandescentIcon = WhiteBalanceIncandescentIcon;
export default WbIncandescentIcon